import graphql from "babel-plugin-relay/macro";
import { useMemo } from "react";
import { useFragment } from "react-relay";

import { useConsolidateNewPlayers_Booking$key } from "./__generated__/useConsolidateNewPlayers_Booking.graphql";

interface ConsolidatedRoundsResult {
  unnamedPlayersCount: number;
}

interface UseConsolidateNewPlayersProps {
  bookingFragmentRef: useConsolidateNewPlayers_Booking$key | null;
}

export const useConsolidateNewPlayers = ({
  bookingFragmentRef,
}: UseConsolidateNewPlayersProps): ConsolidatedRoundsResult => {
  const data = useFragment<useConsolidateNewPlayers_Booking$key>(
    useConsolidateNewPlayersFragmentString,
    bookingFragmentRef
  );

  return useMemo(() => {
    let unnamedPlayersCount = 0;

    data?.rounds?.edges?.forEach((edge) => {
      if (!edge?.node) return;
      const hasFullName = edge.node.player?.fullName;
      if (!hasFullName) {
        unnamedPlayersCount++;
      }
    });

    return {
      unnamedPlayersCount,
    };
  }, [data]);
};

const useConsolidateNewPlayersFragmentString = graphql`
  fragment useConsolidateNewPlayers_Booking on Booking {
    rounds {
      edges {
        node {
          player {
            fullName
          }
        }
      }
    }
  }
`;
